
<script>
import { defineComponent, inject } from 'vue'

export default defineComponent({
  name: "OurRooms",
  setup() {
    const hydrate = inject("hydrate")

    const { prefetch } = hydrate({
      //prefetch:["contactUs"],
      metadata(meta, prefetchData) {
        meta.addTitle("Golden Oaks Motel | Our Rooms")
      //   const seo = contactUs.seo[0]
      //   meta.addTitle(seo.page_title)
      //   meta.addCanonical()
      //   meta.addMetaItem([
      //     { name:'description', content: seo.page_description },
      //     { name:'og:title', content: seo.open_graph_title },
      //     { name:'og:description', content: seo.open_graph_description },
      //     { name:'og:image', content: pathname(seo.open_graph_image.guid) },
      //     { name:'og:image:alt', content: seo.open_graph_image_alt } 
      //   ])
      },
      // preload: ({contactUs}) => [pathname(contactUs.header_image.guid)],
      // watch({ Contact }, watchReveal) {
      //   watchReveal(header,
      //     () => (Contact.preload == 1 && Contact.prefetch == 1)
      //   )
      // }
    })

    return {}

  },
});
</script>


<template>

<div id="top" class="page-header wf-section">
      <div class="page-header-overlay menu">
        <div class="container w-container">
          <div class="section-intro-block">
            <h2 class="section-intro-title">OUR Rooms</h2>
            <h2 class="section-intro-title subtitle">Information and Pricing</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="section white wf-section">
      <div class="container w-container">
        <div class="section-intro-block">
          <h2 class="section-intro-title">Amenities</h2>
          <p>Each room here at the Golden Oaks Motel has a wall-mounted HD TV with a selection of channels from DirecTV, coffee maker, and wireless High Speed Internet. In select rooms we feature fold-out futon couches, and upon request, a microwave cart. All of our rooms are smoke-free. No pets allowed.</p>
          <div class="section-divider-line"></div>
        </div>
        <div class="events-row w-row">
          <div class="contact-us-column w-col w-col-6 w-col-small-6 w-col-tiny-6">
            <div class="event-overview-image">
              <a href="https://goldenoaksmotel.client.innroad.com/" class="image-link-block w-inline-block"></a>
            </div>
          </div>
          <div class="event-column-right w-col w-col-6 w-col-small-6 w-col-tiny-6">
            <div class="intro-title">$94.35</div>
            <a href="#" class="blog-link-title">Single Queen <br />
            </a>
            <div class="section-divider-line"></div>
            <p>Single Queen - Our Single Queen rooms offer a Queen size bed, with a fold-out futon couch and coffee table.</p>
            <a href="https://goldenoaksmotel.client.innroad.com/" class="button blog-read-more">Book Now</a>
          </div>
        </div>
        <div class="events-row w-row">
          <div class="contact-us-column w-col w-col-6 w-col-small-6 w-col-tiny-6">
            <div class="event-overview-image _2">
              <a href="https://goldenoaksmotel.client.innroad.com/" class="image-link-block w-inline-block"></a>
            </div>
          </div>
          <div class="event-column-right w-col w-col-6 w-col-small-6 w-col-tiny-6">
            <div class="intro-title">$116.55</div>
            <a href="#" class="blog-link-title">Double Queen <br />
            </a>
            <div class="section-divider-line"></div>
            <p>Same amenities as the Single Queen, but instead of a fold-out futon there is a second queen size bed. <br />
            </p>
            <a href="https://goldenoaksmotel.client.innroad.com/" class="button blog-read-more">Book Now</a>
          </div>
        </div>
        <div class="events-row w-row">
          <div class="contact-us-column w-col w-col-6 w-col-small-6 w-col-tiny-6">
            <div class="event-overview-image king">
              <a href="https://goldenoaksmotel.client.innroad.com/" class="image-link-block w-inline-block"></a>
            </div>
          </div>
          <div class="event-column-right w-col w-col-6 w-col-small-6 w-col-tiny-6">
            <div class="intro-title">$105.45</div>
            <a href="#" class="blog-link-title">
              <strong>King</strong>
              <br />
            </a>
            <div class="section-divider-line"></div>
            <p>There are three styles of King size rooms to choose from, all offering a king size bed. We have one furnished with a fold-out futon couch and chair, and a standing three-drawer dresser. One is outfitted for our guests with disabilities, with ramp and widened bathroom doorway. The third style offers a fold-out futon couch and coffee table only.</p>
            <a href="https://goldenoaksmotel.client.innroad.com/" class="button blog-read-more">Book Now</a>
          </div>
        </div>
      </div>
    </div>

</template>